__turbopack_context__.v({
  "item": "header-nav-item-module__kt-e0G__item",
  "link": "header-nav-item-module__kt-e0G__link",
  "linkActive": "header-nav-item-module__kt-e0G__linkActive",
});
